export default __webpack_public_path__ + "19f4b88eedbcd9505562f5d3edb0fa92.png";